import { format } from 'date-fns';

// duplicated with one in global
const formatDate = (dateString, dateFormat = 'yyyy-MM-dd HH:mm:ss') => {
  return format(new Date(dateString), dateFormat);
};

export default formatDate;
